module.exports = __webpack_public_path__ + "static/CleverAgile-8309f99113bdc074c991bb9b53f03b58.png";